import { useEffect } from "react"

export const HelperContext = ({style, icon, children, onClose}) => {

    return (
        <div id="help-context">
            <div className="wrapper">
                <div className="modal">
                    <span className="close" onClick={onClose}>&times;</span>                    
                    {children}
                </div>            
            </div>
        </div>
    )
}